import * as React from 'react';

import {
  DialogPositioningBehavior,
  DialogProps,
  DialogType,
  DialogWidget,
  HorizontalOriginOption,
  VerticalOriginOption
} from '@tableau/widgets';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { ExplorerDropdownStyles } from './ExplorerDropdownStyles';

export const EXPLORER_FLYOUT_PANEL_WIDTH = 250;

export interface ExplorerFlyoutPanelProps {
  anchorEl: HTMLElement;
  onCloseRequest: () => void;
  testId: string;
  title: string;
  width?: number;
}

export class ExplorerFlyoutPanel extends React.PureComponent<ExplorerFlyoutPanelProps> {
  public render(): JSX.Element {
    const dialogProps: DialogProps = {
      dialogWidth: this.props.width || EXPLORER_FLYOUT_PANEL_WIDTH,
      anchorEl: this.props.anchorEl,
      positioningBehavior: DialogPositioningBehavior.Anchored,
      anchorOrigin: {
        vertical: VerticalOriginOption.bottom,
        horizontal: HorizontalOriginOption.left
      },
      showFooter: false,
      shouldAdjustPositionOnWindowResize: true,
      testId: this.props.testId,
      type: DialogType.Uber,
      isModal: true,
      isGlassTransparent: true,
      showCloseButton: false,
      handleGlassClick: this.props.onCloseRequest,
      onCloseRequest: this.props.onCloseRequest,
      shouldReturnFocusOnClose: false,
      disableAutoFocus: true,
      // Just setting padding:0 will be ignored due to DialogWidget setting each padding directly
      dialogBodyStyle: {fontWeight: 'normal', paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0},
      dialogStyle: {marginTop: -1},
      title: this.props.title
    };

    return(
      <DialogWidget {...dialogProps}>
        <div className={ExplorerDropdownStyles.FlyoutButtonPanelContainer}>
          {this.props.children}
        </div>
      </DialogWidget>
    );
  }
}
